export default __webpack_public_path__ + "static/media/login_signin.16dffb29.png";